import { v4 as uuid } from 'uuid'
import { getXCLEARCorrelationInfo } from '@api/utils'
import { DiscreteEvent, dispatchCustomEvent, KPI } from '@utils/customEvents'
import type { Enrollment } from '@clear-denver/tpc-openapi-typescript'
import { LookupPipeMeta, PREFIX, SearchType } from './types'

export class LookupFlowSession {
  lookupFlowSessionId = uuid()
  lastEvent = ''
  concluded = false
  meta: LookupPipeMeta | undefined = undefined
  debug = false

  otpAttempts = 0
  disambiguationCount = 0
  searchType: SearchType | '' = ''
  resultVariant: string | undefined = undefined

  get sessionId() {
    return this.lookupFlowSessionId
  }

  get state() {
    return {
      lookupFlowSessionId: this.lookupFlowSessionId,
      lastEvent: this.lastEvent,
      concluded: this.concluded,
      meta: this.meta,
      debug: this.debug,
      otpAttempts: this.otpAttempts,
      disambiguationCount: this.disambiguationCount,
      searchType: this.searchType,
      resultVariant: this.resultVariant,
    }
  }

  trackOtpAttempt(): number {
    this.otpAttempts++
    return this.otpAttempts
  }

  trackDisambiguation(): number {
    this.disambiguationCount++
    return this.disambiguationCount
  }

  trackEvent(label: string) {
    this.lastEvent = label
  }

  resetSession() {
    if (!this.concluded && this.lastEvent) {
      const xCLEARCorrelationInfo =
        this.meta?.xCLEARCorrelationInfo || getXCLEARCorrelationInfo()
      const payload = {
        payload: { message: PREFIX + 'Flow abandoned' },
        metadata: {
          xCLEARCorrelationInfo,
          lookupFlowSessionId: this.lookupFlowSessionId,
          flow: this.meta?.flow ?? 'unknown',
          searchType: this.searchType,
          route: this.meta?.route ?? '',
          kpi: KPI.USER_INTERACTION,
          lastEvent: this.lastEvent,
          step: 'ABANDONED',
          code: 'ABANDONED',
          reason: `Flow abandoned at: ${this.lastEvent}`,
          event: DiscreteEvent.CLIENT_SIDE_ERROR,
        },
      }
      if (this.debug) console.error('[LOOKUP:ABANDONED]', payload)
      dispatchCustomEvent(
        'ERROR' as Enrollment.LogEntryLevelEnum.ERROR,
        payload
      )
    }
    this.lookupFlowSessionId = uuid()
    this.lastEvent = ''
    this.concluded = false
    this.meta = undefined
    this.otpAttempts = 0
    this.disambiguationCount = 0
    this.searchType = ''
    this.resultVariant = undefined
  }

  setDebug(enabled: boolean) {
    this.debug = enabled
  }

  __reset() {
    this.lookupFlowSessionId = 'test-session-id'
    this.lastEvent = ''
    this.concluded = false
    this.meta = undefined
    this.debug = false
    this.otpAttempts = 0
    this.disambiguationCount = 0
    this.searchType = ''
    this.resultVariant = undefined
  }
}

export const session = new LookupFlowSession()
